/* Abstract Events */
export abstract class AmplitudeEvent {
    name: string;
    props?: any;

    constructor(name: string) {
        this.name = name;
    }
}

export type AmplitudeEventSource =
    | "focus-mode"
    | "plan-mode"
    | "explore-mode"
    | "board-view"
    | "calendar-view"
    | "projects-list-view"
    | "projects-details"
    | "menubar";
